import axios from "axios"
import Cookies from 'js-cookie';

const BaseURL = import.meta.env.VITE_BASEURL;

export const GetMonitoredObject = async (params) => {
    const token = Cookies.get('auth_token');
    const response = await axios.get(
        `${BaseURL}/get/getmonitoredobject`, {
        params,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    );
    return response.data;
}

export const GetSetup = async (params) => {
    const token = Cookies.get('auth_token');
    const response = await axios.get(
        `${BaseURL}/get/iotsetup`, {
        params,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    );
    return response.data;
}

export const GetEmail = async (params, signal) => {
    const token = Cookies.get('auth_token');
    const response = await axios.get(
        `${BaseURL}/get/email/${params?.ObjectCode}`, {
        params,
        signal,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    );
    return response.data;
}

export const GetAllEmail = async (params) => {
    const token = Cookies.get('auth_token');
    const response = await axios.get(
        `${BaseURL}/get/all/email`, {
        params,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    );
    return response.data;
}

export const GetCurrent = async (params) => {
    const token = Cookies.get('auth_token');
    const response = await axios.get(
        `${BaseURL}/get/getcurrent`, {
        params,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    );
    return response.data;
}

export const GetHisReading = async (params, signal) => {
    const token = Cookies.get('auth_token');
    const response = await axios.get(
        `${BaseURL}/get/gethisreading`, {
        params, signal, timeout: 60000,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return response.data
}

export const GetHisReadingTest = async (AccountId, ObjectCode, SensorCode, StartDate, EndDate, Time) => {
    const token = Cookies.get('auth_token');
    const response = await axios.get(
        `${BaseURL}/get/gethisreading/test?AccountId=${AccountId}&ObjectCode=${ObjectCode}&SensorCode=${SensorCode}&StartDate=${StartDate}&EndDate=${EndDate}&Time=${Time}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    );
    return response.data
}

export const GetHistorical = async (AccountId, ObjectCode, StartDate, EndDate, ToleransiFill, ToleransiGuncangan) => {
    const token = Cookies.get('auth_token');
    const response = await axios.get(
        `${BaseURL}/get/gethistorycal?AccountId=${AccountId}&ObjectCode=${ObjectCode}&StartDate=${StartDate}&EndDate=${EndDate}&ToleransiFill=${ToleransiFill}&ToleransiGuncangan=${ToleransiGuncangan}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    );
    return response.data
}

export const GetHistoricalBunker = async (params, options = {}) => {
    const token = Cookies.get('auth_token');
    const response = await axios.get(
        `${BaseURL}/get/getspbunker`, {
        params,
        signal: options.signal,
        timeout: options.timeout,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
    return response.data
}

export const GetHistoricalTest = async (AccountId, ObjectCode, StartDate, EndDate, ToleransiFill, ToleransiGuncangan) => {
    const token = Cookies.get('auth_token');
    const response = await axios.get(
        `${BaseURL}/get/gethistorycal/test?AccountId=${AccountId}&ObjectCode=${ObjectCode}&StartDate=${StartDate}&EndDate=${EndDate}&ToleransiFill=${ToleransiFill}&ToleransiGuncangan=${ToleransiGuncangan}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    );
    return response.data
}

export const GetLastSPAL = async (AccountId, ObjectCode, Status) => {
    const token = Cookies.get('auth_token');
    const response = await axios.get(`${BaseURL}/get/getlastspal?AccountId=${AccountId}&ObjectCode=${ObjectCode}&Status=${Status}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return response.data;
}

export const GetSPALActivity = async (AccountId, spal) => {
    const token = Cookies.get('auth_token');
    const response = await axios.get(`${BaseURL}/get/getspalactivity?AccountId=${AccountId}&spal=${spal}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return response.data;
}

export const GetMonitorSensor = async (params, signal) => {
    const token = Cookies.get('auth_token');
    const response = await axios.get(`${BaseURL}/get/getspmontoringsensor`, {
        headers: {
            'Authorization': `Bearer ${token}`
        },
        params, signal, timeout: 60000
    });
    return response.data;
}

export const GetHisLevelConsumtion = async (params, signal) => {
    const token = Cookies.get('auth_token');
    const response = await axios.get(`${BaseURL}/get/gethistorylevelconsumtion`, {
        headers: {
            'Authorization': `Bearer ${token}`
        },
        params, signal, timeout: 60000
    });
    return response.data;
}
